/* SkinVibe BNPL - raty PayU 0% / PayPo "zaplac za 30 dni" pod przyciskiem koszyka.
   - skrypt PayU (250 KB) laduje sie dopiero gdy linia zbliza sie do ekranu
   - ponizej progu rat nie laduje sie wcale - wtedy pokazujemy wlasna linie PayPo
   - kwote bierzemy z tego, co policzyl widget PayU; wlasne wyliczenie to tylko awaryjna sciezka
   - zmiana wariantu przelicza linie (motyw wysyla zdarzenie variant:change, cena w groszach)
   - pomiar: sv_bnpl_view / open / tab / terms -> GA4 (gtag, kolejka) i dataLayer tylko przy zgodzie analitycznej
     (K3 03.10, jak assets/sv-events.js), Shopify.analytics.publish('skinvibe_bnpl_*') zawsze; ID strumienia z ustawienia bloku */
(function () {
  'use strict';

  var SRC = 'https://static.payu.com/res/v2/widget-mini-installments.js';
  var scriptPromise = null;

  function loadPayU() {
    if (window.OpenPayU && window.OpenPayU.Installments) return Promise.resolve();
    if (scriptPromise) return scriptPromise;
    scriptPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = SRC;
      s.async = true;
      s.onload = function () { resolve(); };
      s.onerror = function () { scriptPromise = null; reject(new Error('sv-bnpl: PayU script failed')); };
      document.head.appendChild(s);
    });
    return scriptPromise;
  }

  function money(grosze) {
    return (grosze / 100).toFixed(2).replace('.', ',');
  }

  /* ---------- pomiar ----------
     gtag wstrzykuje kanal Google & YouTube z opoznieniem (QA 25.08: event po 2 s ginal), wiec zdarzenia czekaja w kolejce. */
  var GA4_ID = '';
  /* zgoda (03.10, K3; wzorzec assets/sv-events.js): dataLayer i GA4 tylko przy zgodzie analitycznej z Shopify Customer
     Privacy API. Zdarzenie sprzed decyzji w banerze czeka w kolejce (max ok. 10 min) i idzie po „Akceptuj” (1 s po zgodzie,
     żeby Consentmo zdążył zaktualizować tryb zgody gtag); „Odrzuć” albo brak decyzji przez 10 min = kolejka wyczyszczona.
     Wcześniej: GA4 po DOWOLNEJ decyzji (także po „Odrzuć”, wtedy hity bez cookies), hit przed decyzją bez zgody (gcs=G100, 12.09);
     dataLayer zawsze. K4 (04.10): zgoda sprzed wejścia na stronę (baner nie czekał w tej wizycie) = bez czekania 1 s (wzór sv-quiz). */
  var ga4Ready = false, gaQueue = [], gaPoll = null, gaTries = 0, consentYesAt = 0, consentWaited = false;
  function consentState() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return 'na';
    try {
      if (cp.analyticsProcessingAllowed()) return 'yes';
      var c = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
      return c && c.analytics === 'no' ? 'no' : '';
    } catch (e) { return 'na'; }
  }
  function gaFlush() {
    var st = consentState();
    if (st === '') consentWaited = true;
    if (st === 'no') { gaQueue.length = 0; return true; }
    if (st !== 'yes') return false;
    if (consentWaited) {
      if (!consentYesAt) consentYesAt = Date.now();
      if (Date.now() - consentYesAt < 1000) return false;
    }
    for (var i = 0; i < gaQueue.length; i++) {
      if (gaQueue[i].dl) continue;
      gaQueue[i].dl = true;
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: gaQueue[i].name }, gaQueue[i].data));
      } catch (e) {}
    }
    if (!GA4_ID) { gaQueue.length = 0; return true; }
    if (typeof window.gtag !== 'function') return false;
    if (!ga4Ready) { window.gtag('config', GA4_ID, { send_page_view: false }); ga4Ready = true; }
    while (gaQueue.length) {
      var q = gaQueue.shift();
      try { window.gtag('event', q.name, Object.assign({ send_to: GA4_ID }, q.data)); } catch (e) {}
    }
    return true;
  }
  function gaSend(name, data) {
    gaQueue.push({ name: name, data: data, dl: false });
    if (gaFlush() || gaPoll) return;
    gaTries = 0;
    gaPoll = setInterval(function () {
      gaTries++;
      if (gaFlush() || gaTries > 2400) { clearInterval(gaPoll); gaPoll = null; gaQueue.length = 0; }
    }, 250);
  }
  /* perf 30.09 B-16 (wzorzec Shopify „yield to main thread”): analityka po narysowaniu klatki, żeby dotknięcie najpierw
     zmieniało ekran (lab 30.09 ×4: jeden track() = 20–25 ms, do ~70 ms). Karta w tle = od razu. */
  function afterPaint(cb) {
    if (document.hidden || typeof requestAnimationFrame !== 'function') { cb(); return; }
    requestAnimationFrame(function () { setTimeout(cb, 0); });
  }
  function track(name, data) {
    afterPaint(function () { trackNow(name, data); });
  }
  function trackNow(name, data) {
    var payload = data || {};
    try { gaSend(name, payload); } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('skinvibe_' + name.replace(/^sv_/, ''), payload);
      }
    } catch (e) {}
  }

  /* ---------- zamykanie z animacja (1:1 z oknem konta Shopify i selektorem kraju) ----------
     modal-dialog z motywu zdejmuje [open] natychmiast (display:none). Owijamy hide():
     klasa .svb-modal--closing -> CSS gra wyjazd + gasniecie tla (240 ms) -> animationend
     (albo 320 ms zapasu, gdy prefers-reduced-motion) -> oryginalne hide().
     modal._svbHideNow = natychmiastowe zamkniecie (uzywane przed otwarciem okna PayU). */
  var CLOSING = 'svb-modal--closing';
  function animatedClose(modal) {
    if (modal._svbHideNow || typeof modal.hide !== 'function') return;
    var origHide = modal.hide.bind(modal);
    var inner = modal.querySelector('.svb-modal__inner');
    modal._svbHideNow = function () {
      modal.classList.remove(CLOSING);
      origHide();
    };
    /* przycisk X ma w motywie handler podpiety przez .bind() w konstruktorze - trzyma ORYGINALNE hide(),
       wiec nadpisanie na instancji go nie dosiega (ta sama lekcja co w selektorze kraju):
       przechwytujemy klik wczesniej i blokujemy tamten handler */
    var x = modal.querySelector('[id^="ModalClose-"]');
    if (x) {
      x.addEventListener('click', function (e) {
        e.stopImmediatePropagation();
        modal.hide();
      }, true);
    }
    modal.hide = function () {
      if (modal.classList.contains(CLOSING)) return;
      if (!modal.hasAttribute('open') || !inner) { origHide(); return; }
      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        inner.removeEventListener('animationend', onEnd);
        modal.classList.remove(CLOSING);
        origHide();
      };
      var onEnd = function (e) { if (e.target === inner) finish(); };
      inner.addEventListener('animationend', onEnd);
      modal.classList.add(CLOSING);
      setTimeout(finish, 320);
    };
  }

  /* ---------- zakladki w modalu ---------- */
  function Tabs(modal, onChange) {
    var self = this;
    this.tabs = Array.prototype.slice.call(modal.querySelectorAll('.svb-tab'));
    this.panels = Array.prototype.slice.call(modal.querySelectorAll('.svb-panel'));
    this.index = 0;
    this.defaultIndex = 0;
    this.onChange = onChange || null;
    if (!this.tabs.length) return;

    this.tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { self.show(k, 'click'); });
    });

    modal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { self.show(self.index + 1, 'keys'); self.tabs[self.index].focus(); }
      if (e.key === 'ArrowLeft') { self.show(self.index - 1, 'keys'); self.tabs[self.index].focus(); }
    });

    var wrap = modal.querySelector('.svb-panels');
    if (wrap) {
      var x0 = null;
      var y0 = null;
      wrap.addEventListener('touchstart', function (e) {
        x0 = e.touches[0].clientX;
        y0 = e.touches[0].clientY;
      }, { passive: true });
      wrap.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        /* gest musi byc wyraznie poziomy (2:1), zeby przewijanie szuflady w pionie / po skosie
           nigdy nie przelaczalo zakladki (sprawdzone 12.09 na 375x667, gdzie szuflada sie przewija) */
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 2) {
          self.show(dx < 0 ? self.index + 1 : self.index - 1, 'swipe');
        }
        x0 = null;
        y0 = null;
      }, { passive: true });
    }

    /* stan poczatkowy wymuszamy zawsze - takze przy kazdym otwarciu okna */
    new MutationObserver(function () {
      if (modal.hasAttribute('open')) self.show(self.defaultIndex);
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });

    this.show(0);
  }

  /* how = 'click' | 'keys' | 'swipe' gdy przelacza klientka; bez how = ustawienie programowe (nie mierzymy) */
  Tabs.prototype.show = function (i, how) {
    if (!this.tabs.length) return;
    var next = Math.max(0, Math.min(this.tabs.length - 1, i));
    var prev = this.index;
    var changed = next !== prev;
    this.index = next;
    var idx = this.index;
    this.tabs.forEach(function (t, k) {
      t.setAttribute('aria-selected', k === idx ? 'true' : 'false');
      t.setAttribute('tabindex', k === idx ? '0' : '-1');
    });
    var wrap = this.panels.length ? this.panels[0].parentElement : null;
    var panels = this.panels;
    if (how && changed && wrap) {
      /* kartkowanie: nowy panel startuje z boku (po stronie, w ktora "idziemy"), stary odjezdza w przeciwna */
      var dir = idx > prev ? 1 : -1;
      var incoming = panels[idx];
      var outgoing = panels[prev];
      wrap.classList.add('svb-no-anim');
      incoming.style.transform = 'translateX(' + (dir > 0 ? '100%' : '-100%') + ')';
      void wrap.offsetWidth;
      wrap.classList.remove('svb-no-anim');
      panels.forEach(function (p, k) { p.classList.toggle('is-off', k !== idx); });
      incoming.style.transform = '';
      outgoing.style.transform = 'translateX(' + (dir > 0 ? '-100%' : '100%') + ')';
    } else {
      /* ustawienie programowe (start, otwarcie okna) = natychmiast, bez ruchu */
      if (wrap) wrap.classList.add('svb-no-anim');
      panels.forEach(function (p, k) { p.classList.toggle('is-off', k !== idx); p.style.transform = ''; });
      if (wrap) { void wrap.offsetWidth; wrap.classList.remove('svb-no-anim'); }
    }
    if (how && changed && this.onChange) this.onChange(idx, how);
  };

  /* ---------- linia pod przyciskiem ---------- */
  function Block(el) {
    var self = this;
    this.el = el;
    this.amt = el.querySelector('[data-svb-amt]');
    this.probe = el.querySelector('[data-svb-probe]');
    this.logoPayu = el.querySelector('[data-svb-logo="payu"]');
    this.logoPaypo = el.querySelector('[data-svb-logo="paypo"]');
    this.modal = document.getElementById(el.getAttribute('data-svb-modal'));

    var d = el.dataset;
    this.posId = d.svbPos;
    this.key = d.svbKey;
    this.count = parseInt(d.svbCount, 10) || 15;
    this.minInst = parseInt(d.svbMinInst, 10) || 30000;
    this.minPaypo = parseInt(d.svbMinPaypo, 10) || 1000;
    this.maxPaypo = parseInt(d.svbMaxPaypo, 10) || 800000;
    this.usePayu = d.svbPayu === 'true';
    this.usePaypo = d.svbPaypo === 'true';
    if (d.svbGa4) GA4_ID = d.svbGa4;

    this.offer = '';       /* co widzi klientka: 'payu' (rata) albo 'paypo' (za 30 dni) */
    this.viewed = false;   /* sv_bnpl_view raz na strone */
    this.openWidget = null;
    this.token = 0;
    if (this.modal) {
      var modal = this.modal;
      /* global.js jest defer przed nami, ale czekamy na definicje elementu dla pewnosci */
      if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('modal-dialog').then(function () { animatedClose(modal); });
      } else {
        animatedClose(modal);
      }
    }
    this.tabs = this.modal ? new Tabs(this.modal, function (idx, how) {
      track('sv_bnpl_tab', { offer: idx === 0 ? 'payu' : 'paypo', reason: how });
    }) : null;

    var how = el.querySelector('.svb-line__how');
    if (how) how.addEventListener('click', function () { track('sv_bnpl_open', { offer: self.offer }); });

    this.bindTerms();
    this.observe(parseInt(d.svbPrice, 10));
    this.listenVariant();
  }

  Block.prototype.bindTerms = function () {
    if (!this.modal) return;
    var self = this;
    var link = this.modal.querySelector('[data-svb-terms="payu"]');
    if (link) {
      link.addEventListener('click', function (e) {
        /* tabela rat z RRSO mieszka w oknie PayU; gdy widget nie wstal, zostaje zwykly link */
        var widget = typeof self.openWidget === 'function';
        track('sv_bnpl_terms', { offer: 'payu', reason: widget ? 'widget' : 'link' });
        if (widget) {
          e.preventDefault();
          /* nasze okno chowamy OD RAZU (bez animacji wyjazdu), zeby nie pietrzyc dwoch ciemnych
             warstw - okno PayU (Shadow DOM, warstwa 1e9) pojawia sie natychmiast */
          try {
            if (self.modal && self.modal._svbHideNow) self.modal._svbHideNow();
            else if (self.modal && self.modal.hide) self.modal.hide();
          } catch (err) {}
          self.openWidget();
        }
      });
    }
    var paypo = this.modal.querySelector('[data-svb-terms="paypo"]');
    if (paypo) {
      paypo.addEventListener('click', function () {
        track('sv_bnpl_terms', { offer: 'paypo', reason: 'link' });
      });
    }
  };

  Block.prototype.listenVariant = function () {
    var self = this;
    var timer = null;
    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (!v || v.available === false) { self.hide(); return; }
        self.observe(v.price);
      }, 150);
    });
  };

  Block.prototype.hide = function () {
    this.el.setAttribute('hidden', '');
  };

  /* odslaniamy linie i mierzymy pierwsze pokazanie; reason mowi, DLACZEGO klientka widzi
     wlasnie te oferte: 'ok' = raty policzone, 'below_threshold' = cena ponizej progu rat,
     'payu_failed' = skrypt/widget PayU nie wstal (bloker reklam, siec, isWidgetAvailable=false) */
  Block.prototype.reveal = function (offer, reason, price, installment) {
    this.offer = offer;
    this.el.removeAttribute('hidden');
    if (this.viewed) return;
    this.viewed = true;
    var data = { offer: offer, reason: reason, price: Math.round(price) / 100 };
    if (installment) data.installment = installment;
    track('sv_bnpl_view', data);
  };

  Block.prototype.observe = function (price) {
    var self = this;
    if (!price || isNaN(price)) { this.hide(); return; }

    /* ponizej progu rat nie ma po co ciagnac 250 KB skryptu PayU */
    if (!this.usePayu || price < this.minInst) {
      this.paypoLine(price, 'below_threshold');
      return;
    }
    /* UWAGA: linia startuje z atrybutem hidden (display:none), wiec SAMA nigdy
       nie wejdzie w pole widzenia. Obserwujemy rodzica, ktory jest widoczny. */
    var anchor = this.el.parentElement || this.el;
    if (!('IntersectionObserver' in window)) { this.installments(price); return; }
    if (this._io) this._io.disconnect();
    this._io = new IntersectionObserver(function (entries, obs) {
      if (!entries[0].isIntersecting) return;
      obs.disconnect();
      self.installments(price);
    }, { rootMargin: '200px' });
    this._io.observe(anchor);
  };

  Block.prototype.installments = function (price) {
    var self = this;
    var token = ++this.token;

    loadPayU().then(function () {
      if (token !== self.token) return null;
      self.probe.innerHTML = '';
      return window.OpenPayU.Installments.miniInstallment('#' + self.probe.id, {
        creditAmount: price / 100,
        posId: self.posId,
        key: self.key,
        showLongDescription: true,
        lang: 'pl',
        currencySign: 'PLN',
        excludedPaytypes: ['ppf', 'dpt']
      });
    }).then(function (res) {
      if (token !== self.token || res === null) return;
      if (!res || !res.isWidgetAvailable) throw new Error('installments unavailable');

      self.openWidget = res.openWidget;
      var text = (self.probe.textContent || '').replace(/\s+/g, ' ').trim();
      /* isWidgetAvailable jest true TAKZE ponizej progu rat - widget pisze wtedy "Zaplac pozniej: X zl"
         (zmierzone 12.09: 299,99 -> "Zaplac pozniej", 300,00 -> "Rata 0%"). Bez slowa "rat" w tekscie
         NIE wolno obiecywac rat z wlasnego wyliczenia - pokazujemy linie PayPo. */
      if (!/rat/i.test(text)) throw new Error('no installments for this amount');
      var amount = null;
      var m = text.match(/(\d[\d  ]*,\d{2})/);
      if (m) amount = m[1].replace(/[  ]/g, '');
      if (!amount) amount = money(Math.round(price / self.count));

      /* "/mies." w osobnym elemencie - na najwezszych ekranach chowa je CSS,
         zeby linia zostala JEDNA linia i nie wychodzila poza ekran */
      self.amt.innerHTML = 'Rata 0% już od: <b>' + amount +
        ' zł</b><span class="svb-line__per">/mies.</span>';
      self.logoPayu.removeAttribute('hidden');
      self.logoPaypo.setAttribute('hidden', '');
      if (self.tabs) self.tabs.defaultIndex = 0;
      self.reveal('payu', 'ok', price, parseFloat(amount.replace(',', '.')) || 0);
    }).catch(function () {
      if (token !== self.token) return;
      self.openWidget = null;
      self.paypoLine(price, 'payu_failed');
    });
  };

  Block.prototype.paypoLine = function (price, reason) {
    if (this.probe) this.probe.innerHTML = '';
    if (!this.usePaypo || price < this.minPaypo || price > this.maxPaypo) { this.hide(); return; }
    this.amt.textContent = 'Zapłać za 30 dni';
    this.logoPaypo.removeAttribute('hidden');
    this.logoPayu.setAttribute('hidden', '');
    /* przy tej cenie raty nie wchodza w gre - okno otwiera sie na wlasciwej zakladce */
    if (this.tabs) this.tabs.defaultIndex = 1;
    this.reveal('paypo', reason || 'below_threshold', price);
  };

  function init() {
    document.querySelectorAll('.svb-line[data-svb-pos]').forEach(function (el) {
      if (el._svb) return;
      el._svb = new Block(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
